<template>
  <div
    class="car-life"
    v-if="!categoryCode"
  >
    <div class="car-life-service__wrapper">
      <template v-for="(item, index) in services">
        <div
          v-if="item"
          class="car-life-service"
          :key="index"
          @click="jumpTo(item)"
        >
          <img
            v-if="item.categoryName === productValue.phoneCharge"
            class="icon"
            :src="pic_phone"
          >
          <img
            v-if="item.categoryName === productValue.akeyRefuel"
            class="icon"
            :src="pic_refueling"
          >
          <img
            v-if="item.categoryName === productValue.refuel"
            class="icon"
            :src="pic_refuel"
          >
          <img
            v-if="item.categoryName === productValue.breakrules"
            class="icon"
            :src="pic_breakrules"
          >
          <img
            v-if="item.categoryName === productValue.giftCard"
            class="icon"
            :src="pic_giftcard"
          >
          <img
            v-if="item.categoryName === productValue.mediacard"
            class="icon"
            :src="pic_mediacard"
          >
          <img
            v-if="item.categoryName === productValue.ticket"
            class="icon"
            :src="pic_ticket"
          >
          <div class="text">{{ item.categoryName }}</div>
        </div>
        <div
          class="car-life-service"
          v-if="!item"
          :key="index"
        />
      </template>
    </div>
    <div class="text--bottom">更多服务敬请期待</div>
  </div>
  <div
    class="car-life"
    v-else
  >
    <div class="center_text">跳转对应页面中.....</div>
  </div>
</template>

<script>
import { cookieSet } from '@/common/cookie';

import { carLifeCategory, loginNoToken, carList } from '@/common/api.js';

import pic_phone from '@/assets/img/car-life/phone-charge@2x.png';
import pic_refueling from '@/assets/img/car-life/refueling@2x.png';
import pic_refuel from '@/assets/img/car-life/refuelcard@2x.png';
import pic_giftcard from '@/assets/img/car-life/giftcard@2x.png';
import pic_mediacard from '@/assets/img/car-life/mediacard@2x.png';
import pic_breakrules from '@/assets/img/car-life/breakrules@2x.png';
import pic_ticket from '@/assets/img/car-life/ticket@2x.png';

export default {
  name: 'CarLife',

  data() {
    return {
      pic_phone,
      pic_refueling,
      pic_refuel,
      pic_giftcard,
      pic_mediacard,
      pic_breakrules,
      pic_ticket,
      productValue: {
        phoneCharge: '话费充值',
        akeyRefuel: '一键加油',
        giftCard: '礼品卡',
        breakrules: '违章',
        refuel: '加油卡充值',
        mediacard: '视听卡',
        ticket: '罚单',
        parkViolations: '违章'
      },
      services: [],
      categoryCode: '', // 外部跳转，用这个字段来区分
      productCode: '',
      categoryMap: {
        phoneCharge: 'FL00000002', // 话费充值
        akeyRefuel: 'FL20000002', // 一键加油
        giftCard: 'FL30000002', // 礼品卡
        refuel: 'FL00000003', // 加油卡充值
        mediacard: 'FL30000003', // 视听卡
        ticket: 'FL80000003', // 罚单
        parkViolations: 'FL80000002' // 违章
      }
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      // 处理从小程序入口跳转过来
      if (this.$route.query.token) {
        let token = this.$route.query.token;
        token = (token || '').replace(/\s/g, '+');
        // if (
        //   document.domain.indexOf('vas') > -1 ||
        //   document.domain.indexOf('zengzhi') > -1 ||
        //   document.domain.indexOf('localhost') > -1
        // ) {
        //   cookieSet('token', token);
        // }
        token && cookieSet('token', token);
        if (this.$route.query.phone) {
          cookieSet('phone', this.$route.query.phone);
        }
      }

      if (this.$route.query.categoryCode) {
        this.categoryCode = this.$route.query.categoryCode;
      }
      if (this.$route.query.productCode) {
        this.productCode = this.$route.query.productCode;
      }
      if (
        this.categoryCode &&
        !this.$route.query.authorizeToken &&
        !this.$route.query.token
      ) {
        // 无token，去登录界面
        this.$router.push({
          path: '/',
          query: {
            phone: this.$route.query.phone || '',
            categoryCode: this.categoryCode
          }
        });
        return;
      }

      // 外部对接的
      let token;
      if (this.$route.query.authorizeToken) {
        const res = await loginNoToken({
          channelToken: this.$route.query.authorizeToken,
          companyNo: this.$route.query.companyNo
        });
        token = res.token;
        const mobile = res.mobile;
        localStorage.setItem('_phone', mobile);
      }
      // if (
      //   token &&
      //   (document.domain.indexOf('vas') > -1 || document.domain.indexOf('zengzhi') > -1) ||
      //   document.domain.indexOf('localhost') > -1
      // ) {
      //   cookieSet('token', token);
      // }
      token && cookieSet('token', token);
      if (this.$route.query.phone) {
        cookieSet('phone', this.$route.query.phone);
      }
      // 外部跳转,不请求这个接口
      if (this.categoryCode) {
        if (this.$route.query.companyNo === 'XDCX' && this.$route.query.erId) {
          // 国任跳转三级界面
          this.xdcxJump();
        } else {
          this.externalJump();
        }
      } else {
        this.getServices();
      }
    },
    async getServices() {
      console.log('---getServices---');
      const res = await carLifeCategory({});
      if (!res) {
        this.$router.push({ path: '/' });
        return;
      }
      this.services = res;
      this.services.push(...new Array(3 - (res.length % 3)));
    },
    async externalJump() {
      let path = '';
      if (this.categoryCode === this.categoryMap.phoneCharge) {
        path = '/phoneCharge';
      } else if (this.categoryCode === this.categoryMap.akeyRefuel) {
        path = '/akeyRefuel';
      } else if (this.categoryCode === this.categoryMap.ticket) {
        path = '/ticketCheck';
      } else if (this.categoryCode === this.categoryMap.parkViolations) {
        const res = await carList({ phone: this.$route.query.phone });
        path = res.length > 0 ? '/parkingViolationsCheck' : '/carCheck';
      } else if (this.categoryCode === this.categoryMap.mediacard) {
        if (this.$route.query.rightRulePackageBindId) {
          path = '/chargeView';
        } else {
          path = '/mediaCharge';
        }
      } else if (this.categoryCode === this.categoryMap.refuel) {
        path = '/refuelRecharge';
      } else if (this.categoryCode === this.categoryMap.giftCard) {
        if (this.$route.query.rightRulePackageBindId) {
          path = '/giftRecharge';
        } else {
          path = '/giftSelectProduct';
        }
      }
      if (path) {
        this.$router.replace({
          path: path,
          query: {
            phone: this.$route.query.phone,
            rightRulePackageBindId: this.$route.query.rightRulePackageBindId,
            rightRuleCode: this.$route.query.rightRuleCode,
            source: this.$route.query.source,
            categoryCode: this.categoryCode,
            productCode: this.productCode,
            productSkuCode: this.$route.query.productSkuCode
          }
        });
      }
    },
    // 国任跳转三级界面
    async xdcxJump() {
      let path = '';
      if (this.categoryCode === this.categoryMap.phoneCharge) {
        path = '/phoneCharge';
      } else if (this.categoryCode === this.categoryMap.mediacard) {
        path = '/chargeView';
      } else if (this.categoryCode === this.categoryMap.giftCard) {
        path = '/giftRecharge';
      }

      if (path) {
        this.$router.replace({
          path: path,
          query: {
            phone: this.$route.query.phone,
            categoryCode: this.categoryCode,
            code: this.$route.query.productCode,
            companyNo: this.$route.query.companyNo,
            erId: this.$route.query.erId
          }
        });
      }
    },
    async jumpTo(item) {
      let path = '';
      if (item.categoryName === this.productValue.phoneCharge) {
        path = '/phoneCharge';
      } else if (item.categoryName === this.productValue.akeyRefuel) {
        path = '/akeyRefuel';
      } else if (item.categoryName === this.productValue.ticket) {
        path = '/ticketCheck';
      } else if (item.categoryName === this.productValue.parkViolations) {
        const res = await carList({ phone: this.$route.query.phone });
        path = res.length > 0 ? '/parkingViolationsCheck' : '/carCheck';
      } else if (item.categoryName === this.productValue.mediacard) {
        path = '/mediaCharge';
      } else if (item.categoryName === this.productValue.refuel) {
        path = '/refuelRecharge';
      } else if (item.categoryName === this.productValue.giftCard) {
        path = '/giftSelectProduct';
      }
      if (path) {
        this.$router.push({
          path: path,
          query: {
            phone: this.$route.query.phone,
            productCode: item.productCode,
            categoryCode: item.categoryCode
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.car-life {
  position: relative;
  min-height: 100vh;
  overflow-y: scroll;

  .center_text {
    width: 100%;
    text-align: center;
    margin-top: 4rem;
    font-size: 0.28rem;
  }

  &-service {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 33%;
    height: 3.2rem;
    background: #fff;
    border-right: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    float: left;

    &:nth-child(3n) {
      border-right: none;
    }

    &__wrapper {
      min-height: calc(100vh - 1.4rem);
    }

    .icon {
      width: 0.72rem;
      height: 0.72rem;
      margin-bottom: 0.24rem;
    }

    .text {
      font-size: 0.32rem;
    }
  }

  .text--bottom {
    font-size: 0.32rem;
    width: 100vw;
    text-align: center;
    color: #c8c8c8;
    margin: 0.4rem auto;
  }
}
</style>
